import { FunctionComponent } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { format } from "date-fns";
import dashIcon from "../../assets/calendar-svgrepo-com.svg";
import backArrow from "../../assets/task/back_arrow.svg";
import BreadCumb from "../../components/common/Breadcrumb";
import SkeletonLoader from "../../components/common/SkeletonLoader";
import { showError } from "../../components/common/ToastNotification";
import { GOAL_DETAILS,GET_POD_GOAL } from "../../api/query";
import checkIconimg from "../../assets/task/check-svgrepo-com.svg";

const fmt = (d?: string | null) =>
  d ? format(new Date(d), "MMM dd, yyyy") : "—";

const fmtDatetime = (d?: string | null) =>
  d ? format(new Date(d), "MMM dd, yyyy HH:mm") : "—";

const BADGE_CLASSES = [
  "lightred-statusbg-card",
  "lightgray-statusbg-card",
  "lightgreen-statusbg-card",
  "lightyellow-statusbg-card",
  "lightblue-statusbg-card",
];

const GoalDetailPOD: FunctionComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
 const goalId: number | undefined = (location.state as any)?.goal_id;
  const goalType: "normal" | "pod_goal" =
    (location.state as any)?.goal_type ?? "normal";

const {
  data: normalGoalData,
  loading: normalGoalLoading,
  error: normalGoalError,
} = useQuery(GOAL_DETAILS, {
  fetchPolicy: "no-cache",
  variables: { goal_id: goalId },
  skip: !goalId || goalType === "pod_goal",
  onError: (err) => showError(err.message),
});

const {
  data: podGoalData,
  loading: podGoalLoading,
  error: podGoalError,
} = useQuery(GET_POD_GOAL, {
  fetchPolicy: "no-cache",
  variables: { goal_id: goalId },
  skip: !goalId || goalType !== "pod_goal",
  onError: (err) => showError(err.message),
});

const isPodGoal = goalType === "pod_goal";

const goal = isPodGoal
  ? podGoalData?.get_pod_goal?.goal
  : normalGoalData?.goal_details?.goal_details;

const tasks: any[] = goal?.tasks ?? [];

const tags: any[] = isPodGoal
  ? []
  : goal?.goal_tags_values ?? [];

const members: any[] = isPodGoal
  ? (podGoalData?.get_pod_goal?.members ?? []).map((member: any) => ({
      employee_id: member.employee_id,
      member_name: `${member.first_name ?? ""} ${member.last_name ?? ""}`.trim(),
      role: member.designation,
      image_url: member.image_url,
      skills: member.skills,
      is_cs_person: member.is_cs_person,
    }))
  : goal?.goal_members ?? [];

const statusHistory: any[] = isPodGoal
  ? []
  : goal?.task_status_values ?? [];

const loading = isPodGoal ? podGoalLoading : normalGoalLoading;
const error = isPodGoal ? podGoalError : normalGoalError;




  return (
    <section id="cts-respon-p-dv" className="flex-1 flex flex-col items-start justify-start py-40 px-20 mq575:px-5 box-border gap-[20px] max-w-[100%] mq1425:max-w-full">
      <BreadCumb />

      <div className="self-stretch flex flex-row items-center justify-start gap-[5px]">
        <img
          className="w-6 relative h-6 overflow-hidden shrink-0 cursor-pointer dark-white-img"
          alt=""
          src={backArrow}
          onClick={() => navigate(-1)}
        />
        <h3 className="m-0 flex-1 relative text-inherit font-bold font-inherit inline-block max-w-[calc(100%_-_29px)] mq450:text-base dark:text-white">Goal auto-assignment</h3>

      </div>
      <div className=" flex self-stretch flex-col min-w-full m-0 rounded-radius-radius-lg bg-surface-bg-blue darkborder-b-remove  items-start justify-start p-8 mq575:p-3 box-border gap-[24px] max-w-full mq825:pt-5 mq825:pb-5 mq825:box-border mq1425:pt-[21px] mq1425:pb-[21px] mq1425:box-border">

        {/* Back navigation */}


        {loading ? (
          <SkeletonLoader count={5} height="h-28" className="mb-3" />
        ) : error ? (
          <div className="self-stretch rounded-lg overflow-hidden flex flex-col items-center justify-center py-[60px] bg-slate-100 dark:bg-slate-700">
            <p className="text-sm text-red-500">Failed to load goal details. Please try again.</p>
          </div>
        ) : (
          <>
            {/* Top header row */}
            <div className="topnav-dash-item-dv grid  gap-2 items-center  min-w-full mq825:grid">
              <div className="flex gap-2 items-center mq825:grid justify-between mq:grid">
                <div className="flex gap-2 items-center mq991:grid">
                  <div className="flex gap-2 items-center">
                    <img src={dashIcon} className="w-5 h-5 object-cover" alt="" />
                    <h5 className="my-0 text-xl-dv self-stretch relative text-lg dark:text-white">
                      Goal auto-assignment
                    </h5>
                  </div>
                  <div className="">
                    <span className="cursor-pointer relative text-sm font-body-xs-semi-bold text-colors-text-black dark:text-white text-left inline-block">
                      {goal?.created_on ? fmtDatetime(goal.created_on) : "09:45 IST · 23 Jul"}
                    </span>
                  </div>
                </div>

              </div>
            </div>

            {/* Main content card */}
            <div className="grid self-stretch flex-col gap-[16px] max-w-full lightgray-bg-poddetail">
              <div className="goaldash-card-item-dv p-4 grid gap-4">


                {/* Goal title */}
                <div className="goals_dash_pod_detail">
                  <h5 className="my-0 text-xl-dv self-stretch relative text-lg dark:text-white">
                    {goal?.title || ""}
                  </h5>
                </div>
                <div className="flex flex-wrap gap-1 items-center">

                       {
                          goal?.defect?.symptom && 
                               <span className="lightred-statusbg-card">{goal?.defect?.symptom}</span>
                   
                        }
                           {
                          goal?.defect?.churn_quote && 
                               <span className="lightred-statusbg-card">{goal?.defect?.churn_quote}</span>
                   
                        }
                            {
                            goal?.defect?.request_type && 
                                                 <span className="lightblue-statusbg-card">{goal?.defect?.request_type}</span>
                          }
                  {/* <span className="lightblue-statusbg-card">lightblue status card</span>
                  <span className="lightgreen-statusbg-card">lightblue status card</span>
                  <span className="lightyellow-statusbg-card">lightblue status card</span>
                  <span className="lightgray-statusbg-card">lightblue status card</span> */}
                </div>


                {/* Date info cards */}
                <div className="grid grid-cols-3 mq1400:grid-3 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1  gap-[16px] min-w-full">
                  <div className="goaldash-card-item-dv p-4 grid gap-1">
                    <p className="my-0">Start</p>
                    <h5 className="my-0 text-xl-dv self-stretch relative text-lg dark:text-white">
                      {fmt(goal?.start_date) !== "—" ? fmt(goal?.start_date) : fmt(goal?.actual_start_date) !== "—" ? fmt(goal?.actual_start_date) : "23 Jul, 09:45"}
                    </h5>
                  </div>
                  <div className="goaldash-card-item-dv p-4 grid gap-1">
                    <p className="my-0">Fix by (SLA)</p>
                    <h5 className="my-0 text-xl-dv self-stretch relative text-lg dark:text-white">
                      {fmt(goal?.end_date) !== "—" ? fmt(goal?.end_date) : "Today 23:59 · 13h 42m left"}
                    </h5>
                  </div>
                  {/* <div className="goaldash-card-item-dv p-4 grid gap-1">
                    <p className="my-0">Close by</p>
                    <h5 className="my-0 text-xl-dv self-stretch relative text-lg dark:text-white">
                      {fmt(goal?.actual_end_date) !== "—" ? fmt(goal?.actual_end_date) : "Release + 24h, customer-confirmed"}
                    </h5>
                  </div> */}
                </div>



                {/* Tasks table */}
                <div className="goal-autoassignment-tbl grid w-full emptasklist-tbl">
                  <div className=" viewdoclist_tabel_blg min-w-full overflow-hidden assessorform_main_tbl client-hist-main">
                    <div className=" bg-white dark:dark:bg-slate-700 flex flex-col items-start justify-start gap-[24px] overflow-x-auto client-report-dtnamic-tbl">
                      <table className="table self-stretch border-[1px] border-solid border-surface-border rounded-lg overflow-x-auto dynamictabel-main-dv">
                        <thead className="bg-surface-bg-secondary dark:bg-slate-600">
                          <tr>
                            <th className="relative p-4 text-sm dark:text-white tdth-custom-width">
                              <span className="cursor-pointer"> Task</span>
                            </th>
                            <th className="relative p-4 text-sm dark:text-white tdth-custom-width">
                              <span className="cursor-pointer">Assigned to</span>
                            </th>

                            <th className="relative p-4 text-sm dark:text-white tdth-custom-width">
                              <span className="cursor-pointer">Due</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="">
                          {tasks.length > 0 ? (
                            tasks.map((task: any) => {
                              const taskStatus = task.status_name || task.status;
                              const getTaskHours = (task: any) => {
  if (task.hours != null) {
    return `${task.hours} H`;
  }

  if (task.start_datetime && task.end_datetime) {
    const start = new Date(task.start_datetime).getTime();
    const end = new Date(task.end_datetime).getTime();

    const hours = (end - start) / (1000 * 60 * 60);

    return `${hours.toFixed(2)} H`;
  }

  return "—";
};
                              return(
                              <tr key={task.id}>
                                <td className="tdth-custom-width dark:text-white text-sm ">
                                  <span className="relative commandtbl-top top-removed-dv">
                                    {task.title || task.task || "—"}
                                  </span>
                                </td>
                                <td className="tdth-custom-width dark:text-white text-sm ">
                                  <span className="relative commandtbl-top top-removed-dv">
                                    {task.assigned_to_name}
                                  </span>
                                </td>

                                <td className="tdth-custom-width dark:text-white text-sm gap-2">
                                  <span className="relative commandtbl-top top-removed-dv">
                                     {getTaskHours(task)}
                                  </span>
                                
                                    {
                                     taskStatus == "Closed" && 
                                       <span className="relative commandtbl-top top-removed-dv">
                                    <img src={checkIconimg} className="w-4 h-4 relative top-[2px] due-checkicon" alt="Check" />
                                  </span>
                                    }
                                  
                                
                                </td>
                              </tr>
                            )
                            })
                          ) : (
                            <>

                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Footer legend */}
                <div className="flex gap-3 w-full mq991:grid justify-between">
                  <div className="flex gap-1 items-center">
                    <span className='bluestatus-cricle-dv'></span>
                    <span className="text-sm dark:text-white">
                      {members.length > 0
                        ? `${members.map((m: any) => m.member_name).join(', ')} — ${members.length} member${members.length !== 1 ? 's' : ''}`
                        : "AI agent slot (human fallback named) Station — halts for human review"}
                    </span>
                  </div>
                  {/* <div className="flex gap-1 items-center mq991:items-start">
                    <span>
                      {goal?.created_by_name ? `Created by ${goal.created_by_name}` : " Huddle agenda"}
                    </span>
                  </div> */}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default GoalDetailPOD;
